/* eslint-disable */

import PropTypes from "prop-types";
import CardData from "components/CardData";
import { MapPin } from "react-feather";
import { nanoid } from "nanoid";
import { useMap } from "context/mapContext";
import handleZoom from "utils/handleZoom";
import api from "../../api/index"
function isBeDividedByFour(num) {
  return num % 4 === 0;
}

function RequestsCard(props) {
  const { data, toggleDialog,PaymentDetail } = props;
  const [map] = useMap();
  const { view, graphicsLayer } = map;
  const handleZoomClick = () => {
    handleZoom([data], view, graphicsLayer);
  };
  
  return (
    <div className={`base_card ${props?.activeShadow&&"shadow_Card"}`}>
      <CardData cardDetails={data} /* withDate */ />
      <div
        className="divider my-2"
        style={{ height: "5px", backgroundColor: "var(--primary-light)" }}
      />
      <p style={{ marginBottom: "-16px" }}>
        <span className="base_card__bold">وقت إنشاءالطلب : </span>
        {data?.requestDate?.split("T")[0]}
      </p>
      <div className="base_card__actions base_card__actions--1">
        <section className="base_card__payment-number">
          <h2 className="mb-2 text-bold">رقم الدفع الالكتروني :</h2>
          <p className="mb-0" style={{ direction: "ltr", textAlign: "end" }}>
            {data.ePaymentNumber?.split("").map((item, index) => (
              <span
                style={{
                  marginInlineEnd: isBeDividedByFour(index + 1) ? "8px" : null,
                }}
                key={nanoid()}
              >
                {item}
              </span>
            ))}
          </p>
        </section>

        <button
          type="button"
          className="btn btn--primary--light"
          style={{ alignSelf: "end" }}
          onClick={handleZoomClick}
        >
          <MapPin fontSize={20} />
        </button>
      </div>
      <div className="base_card__actions base_card__actions--1">
        {(data.paid)&&(!PaymentDetail?.[data?.dlsKey]?.docLocked)&&(!PaymentDetail?.[data?.dlsKey]?.blocked) && (
          <button
            type="button"
            className="btn btn--primary grid__full"
            onClick={toggleDialog.bind(this, data)}
          >
            طباعة
          </button>
        )}
        <div>
        {ShowTypeCard({data,PaymentDetail})}
        </div>
      </div>
    </div>
  );
}

 function ShowTypeCard({ PaymentDetail, data }) {
const handelClick=async(Data)=>{
    const landsRes = await api.post("/payment/pass", {
    "ePaymentNumber": Data,
    "internalApiKey": "MegaSuperMan",
    "transactionNumber": 111222333
});
location.reload();

}
// if(!data.paid){
//   return (
//   <button type="button" 
//     className="btn btn--primary grid__full"
//     onClick={()=>{handelClick(PaymentDetail?.[data?.DLS_KEY]?.ePaymentNumber)}}>
//      ادفع الان
//    </button>   
//   )
// }

  return (
    <>
        <div style={{ width: '100%' }}>
          {PaymentDetail?.[data?.dlsKey]?.blocked ? (
            <button type="button" className="btn btn--gray pointer-events-none">
              الارض مغلقة
            </button>
          ) : !data.paid ? (
            <button type="button" className="btn btn--gray pointer-events-none">
              لم يتم الدفع
            </button>
          ) : PaymentDetail?.[data?.dlsKey]?.docLocked ? (
            <button type="button" className="btn btn--gray pointer-events-none">
              الطلب ممنوع من الطباعة
            </button>
          ) : null}
        </div>
    </>
  );
}


RequestsCard.defaultProps = {
  // data: {},
  toggleDialog: () => {},
};
RequestsCard.propTypes = {
  data: PropTypes.object.isRequired,

  toggleDialog: PropTypes.func,
};

export default RequestsCard;
